import { getEnvVar } from '../../utils/env';
// Ensure URL has protocol
const ensureProtocol = (url, fallback) => {
    if (!url)
        return fallback;
    if (url.startsWith('http://') || url.startsWith('https://'))
        return url;
    return `http://${url}`;
};
export const oryConfig = {
    publicUrl: ensureProtocol(getEnvVar('VITE_ORY_PUBLIC_URL'), 'http://localhost:8080'),
    adminUrl: ensureProtocol(getEnvVar('VITE_ORY_ADMIN_URL'), 'http://localhost:4434'),
    adminApiKey: getEnvVar('VITE_ORY_ADMIN_API_KEY'),
    cookieDomain: getEnvVar('VITE_ORY_COOKIE_DOMAIN') || '.aurelius.com',
    cookieSameSite: (getEnvVar('VITE_ORY_COOKIE_SAME_SITE') || 'lax'),
    cookieSecure: getEnvVar('VITE_ORY_COOKIE_SECURE') === 'true',
};
// Helper functions for runtime access
export function getOryPublicUrl() {
    return oryConfig.publicUrl;
}
export function getOryAdminUrl() {
    return oryConfig.adminUrl;
}
export function hasAdminAccess() {
    return !!oryConfig.adminApiKey;
}
